import React from "react";
import { useRouteMatch, Link } from "react-router-dom";

import { faArrowDown, faSeedling, faSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TopNavigation from "./TopNavigation";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DatumLogoSquare from "./DatumLogoSquare";
import { useLocation } from "react-router-dom";


type SideNavigationItem = {
    name: string;
    token: string;
    to: string;
    icon: any
};

const renderTooltip = (messageTooltip: String) => {
    return (
        <Tooltip id="button-tooltip">
             {messageTooltip}
        </Tooltip>
    );
}

const SideBarNav = () => {
    const { path } = useRouteMatch();
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const navigation = [
        { name: 'Fields', token: 'fields', to: `${path}/@${splitLocation[2] ? splitLocation[2].replace("@",'') : ""}/fields${splitLocation[4] ? "/" + splitLocation[4] : ""}`, icon: faSquare },
        { name: 'Plants', token: 'plants', to: `${path}/@${splitLocation[2] ? splitLocation[2].replace("@",'') : ""}/plants${splitLocation[4] ? "/" + splitLocation[4] : ""}`, icon: faSeedling },
        { name: 'Soils', token: 'soils', to: `${path}/@${splitLocation[2] ? splitLocation[2].replace("@",'') : ""}/soils${splitLocation[4] ? "/" + splitLocation[4] : ""}`, icon: faArrowDown },
    ].filter(Boolean) as SideNavigationItem[];

    return (
        <ul className="nav nav-pills nav-flush flex-column flex-nowrap mb-auto mx-auto text-center justify-content-between w-100 px-3 align-items-center pt-2">
            {navigation.map((item, index) => (
                <li className="nav-item" key={item.name}>
                    <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={renderTooltip(item.name)}>
                        <Link className={`nav-link p-2 ${splitLocation[3] === item.token ? "" : "text-white"}`} to={item.to}>
                            <FontAwesomeIcon className="text-2xl" icon={item.icon} />
                        </Link>
                   </OverlayTrigger>
                </li>
            ))}
        </ul>
    );
}

const SideBar = () => {
    return (
        <div className="d-flex flex-column flex-nowrap align-content-between h-100 bg-dark align-items-center sticky-top pt-0 pb-1" style={{ width: "56px" }}>
            <SideBarNav />

            <div className="mb-1">
                <DatumLogoSquare />
            </div>
        </div>
    );
}

type MainLayoutProps = {
    children: React.ReactNode;
};

export const MainLayout = ({ children }: MainLayoutProps) => {
    return (
        <div style={{height:'100%'}}>
            <div className="d-flex flex-column vh-100-1">
                <TopNavigation />
                <div className="flex-grow-1" style={{minHeight: 0, overflow:"hidden"}}>
                    <div className="d-flex h-100">
                        <div className="bg-dark">
                            <SideBar />
                        </div>
                        <main className="flex-grow-1">
                            {children}
                        </main>
                    </div>
                     
                </div>
            </div>
        </div>
    );
}
